import { MdOutlineArrowBackIosNew } from "react-icons/md";

export default function AddChannel({
  createNewChannelSection,
  setCreateNewChannelSection,
}) {
  return (
    <div className="w-full items-center  min-h-[67px] py-2.5 bg-white text-black flex gap-4 px-4 border-b border-[#EBEBEB]">
      <MdOutlineArrowBackIosNew
        className="border border-gray-300 p-1.5 rounded text-3xl cursor-pointer"
        onClick={() => {
          if (createNewChannelSection === 2) {
            setCreateNewChannelSection(1);
          } else if (createNewChannelSection === 3) {
            setCreateNewChannelSection(2);
          } else if (createNewChannelSection === 4) {
            setCreateNewChannelSection(3);
          } else {
            setCreateNewChannelSection(0);
          }
        }}
      />
      <h1 className="text-lg font-semibold text-center">New Channel</h1>
    </div>
  );
}
